<template>
    <CModal
        :title="titleComponent"
        :show="showComponent"
        :color="colorComponent"
        :size="sizeComponent"
    >
        <CForm ref="formCreateUser" @submit="formSubmit($event, 'createUser')">
            <CInput
                :isValid="checkIfFormValid({
                    formName:'createUser',
                    fieldName:'email'
                })"
                :value.sync="$v.forms.createUser.email.$model"
                :label="$t('email')"
            />
            <CInput
                :isValid="checkIfFormValid({
                    formName:'createUser',
                    fieldName:'first_name'
                })"
                :value.sync="$v.forms.createUser.first_name.$model"
                :label="$t('first_name')"
            />
            <CInput
                :isValid="checkIfFormValid({
                    formName:'createUser',
                    fieldName:'last_name'
                })"
                :value.sync="$v.forms.createUser.last_name.$model"
                :label="$t('last_name')"
            />
            <PhoneNumberInput
                :isValid="checkIfFormValid({
                    formName:'createUser',
                    fieldName:'phone'
                })" 
                :value.sync="$v.forms.createUser.phone.$model"
                :label="$t('phone')"
            />

            <PasswordInput
                :isValid="checkIfFormValid({
                    formName:'createUser',
                    fieldName:'password'
                })" 
                :value.sync="$v.forms.createUser.password.$model"
                :label="$t('password')"
            />

            <PasswordInput
                :isValid="checkIfFormValid({
                    formName:'createUser',
                    fieldName:'password_confirmation'
                })" 
                :value.sync="$v.forms.createUser.password_confirmation.$model"
                :label="$t('password_confirmation')"
            />

            <ButtonLoading
                type="submit"
                :block="true"
                color="primary"
                :loading="forms.createUser._loading"
            >
                <span>{{ $t('create_user') }}</span>
            </ButtonLoading>

        </CForm>
        <template #footer>
            <CButton color="secondary" @click="closeModal()">
                {{ $t("cancel") }}
            </CButton>
            <ButtonLoading color="success" @click="executeSubmitForm" :loading="forms.createUser._loading">
                {{ $t("create_user") }}
            </ButtonLoading>
        </template>
    </CModal>
</template>

<script>
import formMixin from '~/mixins/form';
import { validationMixin } from "vuelidate";
import { required, sameAs } from "vuelidate/lib/validators"
import PhoneNumberInput from '~/components/PhoneNumberInput.vue';
import ButtonLoading from '~/components/ButtonLoading.vue';
import PasswordInput from '~/components/PasswordInput.vue';
export default {
    name: "CreateUserModal",
    mixins: [formMixin, validationMixin],
    components: {
        PhoneNumberInput,
        ButtonLoading,
        PasswordInput
    },
    props:{
        title: String,
        show: Boolean,
        color: String,
        size: String,
    },

    data(){
        return {
            titleComponent: null,
            showComponent:false,
            colorComponent: "primary",
            sizeComponent: "lg",

            forms:{
                createUser:{
                    email: null,
                    phone: null,
                    first_name: null,
                    last_name: null,
                    password: null,
                    password_confirmation: null,
                    _loading: false,
                },
            }
        }
    },

    validations:{
        forms:{
            createUser:{
                email:{
                    required
                },
                phone:{
                    required
                },
                first_name:{
                    required
                },
                last_name:{
                    required
                },
                password:{
                    required
                },
                password_confirmation:{
                    required,
                    sameAsPassword: sameAs('password')
                },
            }
        }
    },

    watch:{
        title(){
            this.titleComponent = this.title;
        },
        show(){
            this.showComponent = this.show;
            if(!this.show){
                this.resetForm('createUser');
                this.$v.$reset();
            }
        },
        color(){
            this.colorComponent = this.color;
        },
        size(){
            this.sizeComponent = this.size;
        },

        showComponent(){
            this.$emit('update:show',this.showComponent);
        },
    },

    methods:{
        closeModal(){
            this.showComponent = false;
        },


        async formSubmit(e, formName){
            e.preventDefault();
            let response = await this.sendForm({ 
                formName , 
                url: '/account.api/users/create'
            });
            this.showComponent = false;

            this.$emit('submit',response);
        },

        executeSubmitForm(){
            this.$refs.formCreateUser.requestSubmit();
        }
    },

    mounted(){
        this.titleComponent = this.title;
        this.showComponent = this.show;
        this.colorComponent = this.color;
        this.sizeComponent = this.size;
    },
};
</script>

<style>
</style>